import { ICON_MAP } from './IconLibraryMap';
import { IconName } from './IconLibraryTypes';
import { IconLibraryWeight } from './iconLibraryWeights';
import { useTheme } from '@mui/material';

export interface IconLibraryProps {
  color?: string;
  useContrastColor?: boolean;
  iconName: IconName;
  size?: number;
  weight?: IconLibraryWeight;
  style?: React.CSSProperties;
}

export const IconLibrary = ({
  color,
  useContrastColor = false,
  iconName,
  size = 24,
  weight = 'duotone',
  style,
}: IconLibraryProps) => {
  const theme = useTheme();
  const subColor = useContrastColor ? 'contrastText' : 'main';
  const iconColor =
    theme.palette[color]?.[subColor] || theme.palette.primary?.[subColor];

  const Icon = ICON_MAP[iconName];

  if (!Icon) {
    console.warn(`Icon with name ${iconName} not found in library.`);
    return null;
  }

  return <Icon size={size} weight={weight} color={iconColor} style={style} />;
};
